import React, { createContext, useEffect, useState } from "react";
import { fetchCampaignLogsView } from "../../../../../api";
import CampaignApproved from "./campaignEvents/CampaignApproved";
import CampaignCancelled from "./campaignEvents/CampaignCancelled";
import CampaignCreate from "./campaignEvents/CampaignCreate";
import CampaignPaused from "./campaignEvents/CampaignPaused";
import CampaignUpdate from "./campaignEvents/CampaignUpdate";
import CampaignMoved from "./campaignEvents/CampaignMoved";
import LogRendererLoading from "./LogRendererLoding";
import TargetGroupCreatedAndUpdated from "./targetGroupEvents/TargetGroupCreated";
import { MediaUpdated } from "./mediaEvents/MediaUpdated";
import CampaignClearPaused from "./campaignEvents/CampaignClearPause";
import CampaignClearCancelled from "./campaignEvents/CampaignClearCancel";
import CampaignResumed from "./campaignEvents/CampiagnResume";
import TargetGroupPaused from "./targetGroupEvents/TargetGroupPaused";
import TargetGroupCancelled from "./targetGroupEvents/TargetGroupCancelled";
import TargetGroupClearPaused from "./targetGroupEvents/TargetGroupClearPause";
import TargetGroupClearCancelled from "./targetGroupEvents/TargetGroupClearCancel";
import TargetGroupResumed from "./targetGroupEvents/TargetGroupResume";
import MediaPaused from "./mediaEvents/MediaPaused";
import MediaResumed from "./mediaEvents/MediaResume";
import MediaCancelled from "./mediaEvents/MediaCancelled";
import MediaClearPaused from "./mediaEvents/MediaClearPause";
import MediaClearCancelled from "./mediaEvents/MediaClearCancel";
import { MediaCreated } from "./mediaEvents/MediaCreated";
import CampaignDeleted from "./campaignEvents/CampaignDelete";
import TargetGroupDeleted from "./targetGroupEvents/TargetGroupDeleted";
import MediaDeleted from "./mediaEvents/MediaDeleted";

export const LogRenderContext = createContext();

const LogRenderer = ({ ...props }) => {
  const { editLog } = props;
  const { id } = editLog;
  const { campaignId, userTimeZone } = props;
  const [log, setLog] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchLog = async () => {
      setIsLoading(true);
      try {
        const response = await fetchCampaignLogsView(id);
        setLog(response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching log:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchLog();
    }
  }, [id]);
  if (!isLoading && !log) {
    return null;
  }
  if (isLoading) {
    return <LogRendererLoading />;
  }
  if (!log) {
    return <div>No log found</div>;
  }
  const contextValue = { log, editLog, campaignId, userTimeZone };
  return (
    <LogRenderContext.Provider value={contextValue}>
      <EventComponent />
    </LogRenderContext.Provider>
  );
};
function EventComponent() {
  const { log } = React.useContext(LogRenderContext);
  const [entityType, eventType] = log.eventType.split(".");
  switch (entityType) {
    case "campaign":
      switch (eventType) {
        case "created":
          return <CampaignCreate />;
        case "updated":
          return <CampaignUpdate />;
        case "moved":
        case "move":
          return <CampaignMoved />;
        case "approved":
          return <CampaignApproved />;
        case "paused":
          return <CampaignPaused />;
        case "cancelled":
          return <CampaignCancelled />;
        case "clearPaused":
          return <CampaignClearPaused />;
        case "clearCancelled":
          return <CampaignClearCancelled />;
        case "resumed":
          return <CampaignResumed />;
        case "deleted":
          return <CampaignDeleted />;
        default:
          return <div>Unsupported campaign event type: {eventType}</div>;
      }
    case "targetGroup":
      switch (eventType) {
        case "created":
          return <TargetGroupCreatedAndUpdated type="created" />;
        case "updated":
          return <TargetGroupCreatedAndUpdated type="updated" />;
        case "paused":
          return <TargetGroupPaused />;
        case "cancelled":
          return <TargetGroupCancelled />;
        case "clearPaused":
          return <TargetGroupClearPaused />;
        case "clearCancelled":
          return <TargetGroupClearCancelled />;
        case "resumed":
          return <TargetGroupResumed />;
        case "deleted":
          return <TargetGroupDeleted />;
        default:
          return <div>Unsupported target group event type: {eventType}</div>;
      }
    case "media":
      switch (eventType) {
        case "created":
          return <MediaCreated />;
        case "updated":
          return <MediaUpdated />;
        case "paused":
          return <MediaPaused />;
        case "resumed":
          return <MediaResumed />;
        case "cancelled":
          return <MediaCancelled />;
        case "clearPaused":
          return <MediaClearPaused />;
        case "clearCancelled":
          return <MediaClearCancelled />;
        case "deleted":
          return <MediaDeleted />;
        default:
          return <div>Unsupported media event type: {eventType}</div>;
      }
    default:
      return <div>Unsupported entity type: {entityType}</div>;
  }
}

export default LogRenderer;
